/** `/grid_autorefresh/` — audit-only record that the user turned on a grid's
 * auto-refresh. Writes one `grid.autorefresh.enabled` audit row; nothing is
 * stored (the interval lives in the browser tab). Called BEFORE polling starts
 * — see `components/DataGrid/useGridAutoRefresh.ts`. Hand-authored wrapper
 * (console convention).
 */
import { apiPost } from './client';

export interface GridAutorefreshRecord {
  /** The grid's codename (its preset grid key, e.g. `bookings`). */
  grid: string;
  interval_seconds: number;
  /** The period in effect before this pick; 0 = auto-refresh was off. */
  previous_interval_seconds: number;
  /** Pathname only — never the query string (it can carry guest names / emails). */
  path: string;
}

export function recordEnabled(body: GridAutorefreshRecord): Promise<void> {
  return apiPost<void>('/grid_autorefresh/', body);
}
